import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface ChartSkeletonProps {
  type?: 'bar' | 'radar' | 'line';
  height?: number;
}

export const ChartSkeleton: React.FC<ChartSkeletonProps> = ({ type = 'bar', height = 300 }) => {
  if (type === 'radar') {
    return (
      <div className="w-full touch-pan-y" style={{ height }}>
        <div className="flex items-center justify-center h-full">
          <Skeleton className="w-48 h-48 md:w-64 md:h-64 rounded-full" />
        </div>
      </div>
    );
  }

  if (type === 'line') {
    return (
      <div className="w-full space-y-3" style={{ height }}>
        <div className="flex items-end justify-between h-full px-4">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} className="w-12 rounded-full" style={{ height: `${40 + Math.random() * 60}%` }} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full space-y-3 p-4" style={{ height }}>
      {[...Array(5)].map((_, i) => (
        <div key={i} className="flex items-center gap-4">
          <Skeleton className="h-4 w-16 flex-shrink-0" />
          <Skeleton className="h-6 rounded" style={{ width: `${40 + Math.random() * 50}%` }} />
        </div>
      ))}
    </div>
  );
};

export const ProfileCardSkeleton: React.FC = () => (
  <div className="bg-card border border-border rounded-lg p-4 md:p-6 space-y-4">
    <div className="flex items-center gap-4">
      <Skeleton className="h-16 w-16 rounded-full" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-4 w-48" />
      </div>
    </div>
    <div className="space-y-3">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-5/6" />
    </div>
  </div>
);

export const DataCardSkeleton: React.FC = () => (
  <div className="bg-card border border-border rounded-lg p-4 space-y-3">
    <div className="flex items-center justify-between">
      <Skeleton className="h-5 w-24" />
      <Skeleton className="h-8 w-8 rounded" />
    </div>
    <Skeleton className="h-8 w-16" />
    <Skeleton className="h-3 w-full" />
  </div>
);

export const TableSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
  <div className="space-y-3">
    <div className="flex gap-4 pb-3 border-b border-border">
      {[...Array(4)].map((_, i) => (
        <Skeleton key={i} className="h-4 flex-1" />
      ))}
    </div>
    {[...Array(rows)].map((_, i) => (
      <div key={i} className="flex gap-4 py-3">
        {[...Array(4)].map((_, j) => (
          <Skeleton key={j} className="h-4 flex-1" />
        ))}
      </div>
    ))}
  </div>
);
